<template>
  <div class="">
    <div class="">
      <div class="dialog-header">
        <div class="image">
          <icon :type="'xero'" />
        </div>
        <h1>Xero Log</h1>

        <div class="dialog-header pt-0">
          <div class="row">
            <div class="col-12 text-center">
              <p class="m-0">Review your recent Xero integration activity below. Errors and successful actions are listed with relevant details for troubleshooting or confirmation.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="container-fluid data-container mw-1940">
        <main class="bd-main bd-main-alt">
          <div class="row">
            <div class="col-12">
              <k-checkbox size="large" class="white-checkbox" @change="showErrorLog($event)">
                <span>Show Error Messages</span>
              </k-checkbox>
              <div class="d-none d-lg-block mt-5">
                  <k-grid 
                   class="xero-list-grid" 
                  :data-items="result"
                   :pageable='pageable' 
                   :page-size="pageSize" 
                   :sortable="true"
                  :total="count" 
                  :skip="skip" 
                  :take="take" 
                  :columns="columns" 
                  @pagechange="pageChangeHandler"
                  @sortchange="sortChangeHandler" 
                  :style="{ height: 'auto' }" 
                  :resizable="true"
                  :row-render="cellFunction">
                </k-grid>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
    <div class="dialog-footer">
      <div class="row justify-content-center pt-5">
        <div class="col-12 col-lg-5 text-center">
          <k-button class="btn btn-lg btn-outline-primary w-100" type="button" @click="cancel()">Cancel</k-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import BusinessService from "../../services/business-service";
import icon from "../../components/Icon.vue";
import store from "@/store";
import { useToast } from "vue-toastification";

const toast = useToast();

const columnsData = [
  { field: "formatedTimeOfRequest", title: "Date/Time", width: "220px" },
  { field: "endPoint", title: "End Point", width: "220px" },
  { field: "httpMethod", title: "Method", width: "150px" },
  { field: "statusCode", title: "Code", width: "150px" },
  { field: "errorMessage", title: "Message", width: "250px" }
];

export default {
  components: {
    icon
  },
  data: function () {
    return {
      xerolog: [],
      skip: 0,
      take: 10,
      pageSize: 10,
      sortDirection: 'desc',
      count: 0,
      filter: null,
      sortable: true,
      showError: false,
      pageable: {
        buttonCount: 5,
        info: true,
        type: "numeric",
        pageSizes: true,
        previousNext: true
      },
      columns: columnsData
    };
  },
  computed: {
    result() {
      if (this.xerolog) {
        return this.xerolog
      }
      return [];
    },
    total() {
      return this.count;
    }
  },
  mounted() {
    this.defineColumns();
    this.getXerolog();
    const pageChangeEvent = {
      page:
      {
        skip: 0,
        take: 10,
      }
    }
    this.pageChangeHandler(pageChangeEvent);
  },
  methods: {
    getXerolog() {
      if (!store.getters.businessID) {
        return;
      }

      BusinessService.getXeroLog(this.skip, this.take, this.sortDirection, this.showError)
        .then((response) => {
          if (response.xeroList) {
            this.xerolog = response.xeroList;
            this.count = response.count;
          }
        }).catch(this.showAlert);
    },
    defineColumns() {
      this.columns = columnsData.map((column) => {
        return {
          field: column.field,
          title: column.title,
          format: column.format,
          minGridWidth: column.minGridWidth,
          cell: column.cell,
          width: column.width
        };
      });
    },
    cancel() {
      this.$emit("closePopup");
    },
    pageChangeHandler(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
      this.getXerolog();
    },
    sortChangeHandler: function (e) {
      this.sort = e.sort;
      if (e.event.field === 'formatedTimeOfRequest') {
        if (this.sortDirection === 'asc') {
          this.sortDirection = 'desc'
        }
        else if (this.sortDirection === 'desc') {
          this.sortDirection = 'asc'
        }

        this.getXerolog();
      }
    },
    cellFunction: function (h, trElement, defaultSlots, props) {
      const check = props.dataItem.statusCode !== 200;

      const red = {
        backgroundColor: "rgb(243, 23, 0, 0.32)",
      };
      const trProps = {
        style: check ? red : '',
      };

      return h(
        'tr',
        trProps,
        defaultSlots);
    },
    showErrorLog(event) {
      this.showError = event.value;
      this.skip = 0;
      this.take = 10;
      this.getXerolog();
    },
    showAlert() {
      toast.error("Something went wrong! Please try again.");
    },

  }
};

</script>
